import * as React from 'react'
import Svg, { Circle, Defs, LinearGradient, Stop, SvgProps } from 'react-native-svg'

export const SmallGradientCircle = (props: SvgProps) => (
  <Svg width={36} height={36} fill='none' viewBox='-2 -2 36 36' {...props}>
    <Circle cx={16} cy={17} r={16} fill='url(#a)' />
    <Defs>
      <LinearGradient id='a' x1={3} y1={6} x2={32} y2={24} gradientUnits='userSpaceOnUse'>
        <Stop stopColor='#FF3E6C' />
        <Stop offset={1} stopColor='#4071EB' />
      </LinearGradient>
    </Defs>
  </Svg>
)
